import { render, staticRenderFns } from "./CampaignCouponDiscountList.vue?vue&type=template&id=4d727309&scoped=true"
import script from "./CampaignCouponDiscountList.vue?vue&type=script&lang=js"
export * from "./CampaignCouponDiscountList.vue?vue&type=script&lang=js"
import style0 from "./CampaignCouponDiscountList.vue?vue&type=style&index=0&id=4d727309&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d727309",
  null
  
)

export default component.exports